<template>
  <v-container fluid>
    <!-- LISTAGEM DOS AGENDAMENTOS -->
    <v-card>
      <v-card-title>
        <h3>Gerenciar agendamentos</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-col
        class="px-2 py-0 ma-0"
        v-for="data in system.alerts"
        :key="data.ordem"
        :loading="myloadingvariable"
      >
        <v-alert
          v-model="data.index"
          border="left"
          v-if="data.type == 'success'"
          type="success"
          dismissible
          elevation="10"
        >
          {{ data.message }}
        </v-alert>
        <v-alert
          v-model="data.index"
          border="left"
          v-if="data.type == 'warning'"
          type="warning"
          dismissible
          elevation="10"
        >
          {{ data.message }}
        </v-alert>
      </v-col>
      <v-card-text>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '3'">
            <v-autocomplete
              v-model="IdUnidadeFiltro"
              :items="unidadesList"
              item-text="Unidade"
              item-value="IdUnidade"
              label="Unidade"
              @change="[getAgendamentos($event)]"
              hide-details
              outlined
              dense
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '3'" v-if="empresasFilter.length>0">
            <v-autocomplete
                v-model="IdEmpresa"
                :items="empresasFilter"
                item-text="RazaoSocialWithCNPJ"
                item-value="IdEmpresa"
                label="Empresa"
                @change="[getAgendamentos($event)]"
                hide-details
                outlined
                dense
                clearable
            >
            </v-autocomplete>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '3'" v-if="credenciadosFilter.length>0">
            <v-autocomplete
                v-model="IdCredenciado"
                :items="credenciadosFilter"
                item-text="Nome"
                item-value="IdProfissional"
                label="Credenciado"
                @change="[getAgendamentos($event)]"
                hide-details
                outlined
                dense
                clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '3'">
            <v-autocomplete
              v-model="IdMes"
              :items="periodosList"
              item-text="Mes"
              item-value="IdMes"
              label="Mês"
              @change="[getAgendamentos($event)]"
              hide-details
              outlined
              dense
              clearable
            ></v-autocomplete>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '3'">
            <v-select
              v-model="IdAno"
              :items="anoList"
              item-text="IdAno"
              item-value="IdAno"
              label="Ano"
              @change="[getAgendamentos($event)]"
              hide-details
              outlined
              dense
              clearable
            ></v-select>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '3'">
            <v-select
              v-model="TipoFiltro"
              :items="etiquetasList"
              item-text="titulo"
              item-value="IdEtiqueta"
              label="Tipo"
              @change="[getAgendamentos($event)]"
              hide-details
              outlined
              dense
              clearable
            ></v-select>
          </v-col>
          <v-col :cols="dynamicCol"
            v-if="IdUnidadeFiltro != null || IdEmpresa != null || IdCredenciado != null || IdMes != null || IdAno != null || TipoFiltro != null"
          >
            <v-btn
              color="primary"
              block
              v-bind:id="(dynamicCol = '2.5')"
              @click="[(dynamicCol = 3), limparFiltros()]"
              dark
            >
              Limpar Filtros
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '6'" sm="8" md="9" lg="9" xl="10">
            <v-text-field
              v-model="search"
              prepend-icon="mdi-feature-search-outline"
              label="Pesquisar"
              clearable
            ></v-text-field>
          </v-col>
          <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '6'" sm="4" md="3" lg="3" xl="2">
            <v-btn
              block
              color="primary"
              class="mt-3"
              @click="
                [
                  (system.modelCadEvento = !system.modelCadEvento),
                  zerarCampos(),
                ]
              "
              dark
            >
              <v-icon left>mdi-calendar-plus</v-icon>
              Novo Agendamento
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="agendamentosList"
          :search="search"
          class="elevation-1"
          :loading="myloadingvariable"
          loading-text="Carregando..."
        >
          <template v-slot:[`item.dataInicial`]="{ item }">
            {{ $moment(item.dataInicial).format("L") }}
          </template>
          <template v-slot:[`item.statusProcesso`] = "{ item }">
            <td class="justify-content-center">
              <div class="pt-1 pb-1">
                <StatusProcesso :status="item"></StatusProcesso>
              </div>
              <div class="pb-1 text-center justify-center align-center center">
                <v-chip :style="`background-color: ${item.cor}`" :dark="item ? true : false">{{item.tituloEtiqueta}}</v-chip>
              </div>
            </td>
          </template>
          <template v-slot:[`item.actions`]="{ item }">

            <OcorrenciasProcesso :IdAgendamento="item.IdAgendamento" title="Gerenciar ocorrências"></OcorrenciasProcesso>

            <v-tooltip bottom v-if="item.anexos.length > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="myloadingvariable || notificacaoEmAndamento"
                  icon
                  @click="
                    [viewAnexos(item.anexos), (system.modalAnexos = true)]
                  "
                >
                  <v-icon>mdi-file-eye</v-icon>
                </v-btn>
              </template>
              <span>Visualizar anexos</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="myloadingvariable || notificacaoEmAndamento || item.IdStatusProcesso > 1"
                  icon
                  @click="[checkNotificationsAgendamento(item.IdAgendamento)]"
                >
                  <v-icon :color="item.notificacao_por_email ? 'blue' : 'red'">mdi-email</v-icon>
                </v-btn>
              </template>
              <span>Enviar notificação por email</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="myloadingvariable || notificacaoEmAndamento || item.IdStatusProcesso > 1"
                  icon
                  @click="
                    [
                      loadEvento(
                        item.IdAgendamento,
                        item.IdEmpresa,
                        item.IdUnidade,
                        item.IdContrato
                      ),
                      (system.modelCadEvento = true),
                      (system.btnlEditEvento = true),
                    ]
                  "
                >
                  <v-icon color="green">mdi-calendar-edit</v-icon>
                </v-btn>
              </template>
              <span>Editar agendamento</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="myloadingvariable || notificacaoEmAndamento"
                  icon
                  @click="[exportarTrabalhadores(item.IdAgendamento)]"
                >
                  <v-icon color="primary">mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Baixar relação de trabalhadores</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  :disabled="myloadingvariable || notificacaoEmAndamento || item.IdStatusProcesso > 1"
                  icon
                  @click="[deleteEvento(item.IdAgendamento)]"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir agendamento</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <!-- CADASTRO DOS AGENDAMENTOS -->
    <v-dialog scrollable width="95%" v-model="system.modelCadEvento" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card :loading="myloadingvariable">
        <v-card-title>
          <v-row>
            <v-col cols="12">
              <h3 v-if="system.btnlEditEvento">Editar agendamento</h3>
              <h3 v-else>Novo Agendamento</h3>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-if="system.alertError"
                v-model="system.alertError"
                dismissible
                type="error"
              >
                <ul>
                  <li v-for="error in system.alertInfo" :key="error.index">
                    {{ error[0] }}
                  </li>
                </ul>
              </v-alert>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '9'">
                <v-text-field
                  v-model="cadastro.titulo"
                  label="Adicionar título"
                ></v-text-field>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '3'">
                <v-autocomplete
                    v-model="cadastro.IdEtiqueta"
                    :items="etiquetasList"
                    item-text="titulo"
                    item-value="IdEtiqueta"
                    label="Tipo de atendimento">
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <v-menu
                    v-model="dateTimes.menuDataSaida"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="datasFormatadas.dataSaida"
                        label="Data de saída do SESI"
                        prepend-icon="event"
                        v-mask="'##/##/####'"
                        v-bind="attrs"
                        v-on="on"
                        placeholder="DD/MM/AAAA"
                        @input="atualizarDataDigitada('dataSaida', $event)"
                        @click:prepend="abrirMenuData('menuDataSaida')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="cadastro.dataSaida"
                      @input="selecionarDataSaida"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <v-menu
                    ref="menuHoraSaida"
                    v-model="dateTimes.menuHoraSaida"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="cadastro.horaSaida"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="cadastro.horaSaida"
                        label="Hora de saída"
                        v-mask="'##:##'"
                        v-bind="attrs"
                        append-icon="mdi-clock-outline"
                        placeholder="HH:MM"
                        :error-messages="mensagemHoraInvalida(cadastro.horaSaida)"
                        @input="atualizarHoraSaida"
                        @click:append="abrirMenuHora('horaSaida', 'menuHoraSaida')"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                      v-if="dateTimes.menuHoraSaida"
                      v-model="cadastro.horaSaida"
                      full-width
                      format="24hr"
                      @click:minute="
                      [
                        $refs.menuHoraSaida.save(cadastro.horaSaida),
                      ]
                    "
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <v-menu
                  v-model="dateTimes.menuDataInicial"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="datasFormatadas.dataInicial"
                      label="Previsão de chegada"
                      prepend-icon="event"
                      v-mask="'##/##/####'"
                      :disabled="cadastro.dataSaida == ''"
                      v-bind="attrs"
                      v-on="on"
                      placeholder="DD/MM/AAAA"
                      @input="atualizarDataDigitada('dataInicial', $event)"
                      @click:prepend="abrirMenuData('menuDataInicial')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :min="cadastro.dataSaida"
                    v-model="cadastro.dataInicial"
                    @input="selecionarDataInicial"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <v-menu
                  ref="menuHoraInicial"
                  v-model="dateTimes.menuHoraInicial"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="cadastro.horaInicial"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="cadastro.horaInicial"
                      label="Previsão de chegada"
                      v-mask="'##:##'"
                      :disabled="!horaValida(cadastro.horaSaida)"
                      v-bind="attrs"
                      append-icon="mdi-clock-outline"
                      placeholder="HH:MM"
                      :error-messages="mensagemHoraInvalida(cadastro.horaInicial)"
                      @input="atualizarHoraInicial"
                      @click:append="abrirMenuHora('horaInicial', 'menuHoraInicial')"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="dateTimes.menuHoraInicial"
                    v-model="cadastro.horaInicial"
                    full-width
                    format="24hr"
                    @click:minute="
                      [
                        $refs.menuHoraInicial.save(cadastro.horaInicial),
                        (cadastro.horaFinal = ''),
                        (credenciadosList = []),
                        (tecnicosList = []),
                        getTecnicos($event),
                        atualizarCredenciadosParaAgendamento(),
                      ]
                    "
                    :min="verificaHoraChegada"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <!-- <v-text-field label="Data Final"></v-text-field> -->
                <v-menu
                  v-model="dateTimes.menuDataFinal"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="datasFormatadas.dataFinal"
                      label="Previsão de saída da empresa"
                      prepend-icon="event"
                      v-mask="'##/##/####'"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="cadastro.dataInicial == ''"
                      placeholder="DD/MM/AAAA"
                      @input="atualizarDataDigitada('dataFinal', $event)"
                      @click:prepend="abrirMenuData('menuDataFinal')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    :min="cadastro.dataInicial"
                    v-model="cadastro.dataFinal"
                    @input="selecionarDataFinal"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <!-- <v-text-field label="Hora Final"></v-text-field> -->
                <v-menu
                  ref="menuHoraFinal"
                  v-model="dateTimes.menuHoraFinal"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="cadastro.horaFinal"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="cadastro.horaFinal"
                      label="Previsão de saída"
                      v-mask="'##:##'"
                      v-bind="attrs"
                      :disabled="!horaValida(cadastro.horaInicial)"
                      append-icon="mdi-clock-outline"
                      placeholder="HH:MM"
                      :error-messages="mensagemHoraInvalida(cadastro.horaFinal)"
                      @input="atualizarHoraFinal"
                      @click:append="abrirMenuHora('horaFinal', 'menuHoraFinal')"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="dateTimes.menuHoraFinal"
                    v-model="cadastro.horaFinal"
                    full-width
                    format="24hr"
                    @click:minute="
                      [
                        $refs.menuHoraFinal.save(cadastro.horaFinal),
                        (credenciadosList = []),
                        atualizarCredenciadosParaAgendamento(),
                      ]
                    "
                    :min="verificaHoraSaida"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '4'">
                <v-autocomplete
                  v-model="cadastro.IdUnidade"
                  :items="unidadesList"
                  item-text="Unidade"
                  item-value="IdUnidade"
                  label="Unidade"
                  @change="
                    [
                      (tecnicosList = []),
                      (contratosList = []),
                      (cadastro.IdContrato = null),
                      limparServicosSelecionados(),
                      (credenciadosList = []),
                      getTecnicos($event),
                      getEmpresas($event)
                    ]
                  "
                ></v-autocomplete>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '4'">
                <v-autocomplete
                  v-model="cadastro.IdEmpresa"
                  :items="empresasList"
                  item-text="RazaoSocial"
                  :disabled="
                    !horaValida(cadastro.horaInicial) ||
                    cadastro.IdUnidade == null ||
                    cadastro.dataInicial == '' ||
                    !horaValida(cadastro.horaFinal)
                  "
                  item-value="IdEmpresa"
                  prepend-icon="mdi-factory"
                  :label="labelEmpresaSituacao"
                  :color="colorBloqueada"
                  @input="
                    [
                      (credenciadosList = []),
                      limparServicosSelecionados(),
                      getNumEmpregados($event),
                      getContratos($event),
                      getEmpresaBloqueada($event),
                    ]
                  "
                ></v-autocomplete>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <v-autocomplete
                  v-model="cadastro.IdContrato"
                  :items="contratosList"
                  item-text="Contrato"
                  item-value="IdContrato"
                  label="Termo/Contrato"
                  prepend-icon="mdi-file-document-outline"
                  :disabled="cadastro.IdEmpresa == null || contratosList.length == 0"
                  @input="getProcedimentosContrato($event)"
                ></v-autocomplete>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <v-select
                  ref="taxaDeslocamentoSelect"
                  v-model="cadastro.cobrarTaxaDeslocamento"
                  :items="deslocamento"
                  item-text="name"
                  item-value="id"
                  label="Taxa de deslocamento"
                  @change="cadastro.cobrarTaxaDeslocamento = $event"
                  clearable>
                </v-select>
              </v-col>
            </v-row>
            <v-row v-for="(credenciado, index) in credenciadosAdd" :key="index">
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '4'">
                <v-autocomplete
                  v-model="credenciadosCad[index].IdProcedimento"
                  :items="procedimentosList"
                  item-text="ServicoContratado"
                  item-value="IdProcedimento"
                  :label="`Serviços que constam no termo`"
                  :disabled="cadastro.IdContrato == null"
                  readonly
                ></v-autocomplete>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '4'">
                <v-autocomplete
                  v-model="credenciadosCad[index].IdProfissional"
                  :items="credenciadosDoServico(credenciadosCad[index].IdProcedimento)"
                  item-text="Nome"
                  item-value="IdProfissional"
                  prepend-icon="mdi-account-multiple"
                  label="Selecione o profissional"
                ></v-autocomplete>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <v-text-field
                  v-model="credenciadosCad[index].quantidadePessoas"
                  type="number"
                  :label="'Quantidade ( funcionários: ' + numEmpregados + ')'"
                  min="1"
                  :max="numEmpregados"
                ></v-text-field>
              </v-col>
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '2'">
                <v-btn
                  v-if="credenciadosAdd > 1 && !system.btnlEditEvento"
                  @click="[removeCredenciado(index)]"
                  color="red"
                  class="mt-3 ml-3"
                  x-small
                  fab
                  dark
                >
                  <v-icon>mdi-account-multiple-minus</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row v-if="system.btnlEditEvento">
              <v-col :cols="$vuetify.breakpoint.mdAndDown ? '12' : '4'">
                <v-autocomplete
                  v-model="servicoParaAdicionar"
                  :items="servicosDisponiveisParaAdicionar"
                  item-text="ServicoContratado"
                  item-value="IdProcedimento"
                  label="Adicionar serviço do termo"
                  :disabled="servicosDisponiveisParaAdicionar.length === 0"
                  @change="adicionarServicoAoAgendamento($event)"
                  clearable
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <Multiselect
                   deselect-label="Remova o técnico"
                   select-label="Selecione o técnico"
                   :disabled="tecnicoSelect==false"
                   v-model="tecnicos"
                   :placeholder="tecnicosPlaceholder"
                   label="nome" track-by="IdProfissional"
                   :options="tecnicosList"
                   :multiple="true"
                   :taggable="true"
                ></Multiselect>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  small-chips
                  show-size
                  multiple
                  label="Anexos"
                  ref="files"
                  v-model="files"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row v-if="system.btnlEditEvento" class="mb-4">
              <v-chip
                v-for="(item, i) in cadastro.anexos"
                :key="i"
                class="ma-2"
                close
                color="primary"
                outlined
                @click="docOpen(item)"
                @click:close="deletarAnexo(item.id)"
              >
                <v-icon left>mdi-file-pdf</v-icon>
                {{ item.originalName }}
              </v-chip>
            </v-row>            
            <v-row>
              <v-col cols="12">
                <v-textarea                  
                  auto-grow
                  v-model="cadastro.descricao"
                  class="mr-2 ml-2"
                  outlined
                  label="Observações gerais"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                    auto-grow
                    v-model="cadastro.descricaoInterno"
                    class="mr-2 ml-2"
                    outlined
                    label="Observações de uso interno"                    
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-icon left>mdi-email</v-icon>
                <span class="text--secondary">E-mail da empresa:</span>
                <div v-if="emailsEmpresa" class="ml-8">
                  {{ emailsEmpresa }}
                </div>
                <span v-else class="text--disabled ml-2">Não informado</span>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              [
                (system.modelCadEvento = !system.modelCadEvento),
                (system.btnlEditEvento = false),
                zerarCampos(),
              ]
            "
            large
            dark
          >
            Cancelar
          </v-btn>
          <v-btn
            v-show="system.btnlEditEvento"
            @click="
              [
                (system.modelRemoveCredenciado = !system.modelRemoveCredenciado),
                recarregarServicos(cadastro.IdAgendamento),
              ]
            "
            color="red"
            large
            dark
            >Remover serviço(s)</v-btn
          >
          <v-btn
            v-if="system.btnlEditEvento"
            @click="editEvento(cadastro.IdAgendamento)"
            color="primary"
            :disabled="!agendamentoPodeSalvar"
            large
            dark
            >Atualizar</v-btn
          >
          <v-btn
            :loading="myloadingvariable"
            v-else
            @click="cadEvento()"
            color="primary"
            :disabled="!agendamentoPodeSalvar"
            large
            dark
            >Cadastrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- CADASTRO DE ETIQUETAS -->
    <v-dialog width="50%" v-model="diagEtiquetas" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title>Nova Etiqueta</v-card-title>
        <v-card-text class="justify-center align-center">
          <v-form>
            <v-text-field v-model="etiquetaTitle" label="Título"></v-text-field>
            <v-color-picker
              v-model="etiquetaColor"
              width="100%"
              class="ma-2"
              hide-canvas
              hide-inputs
              show-swatches
              disabled
            ></v-color-picker>
          </v-form>
          <v-switch
            class="mt-6 ml-3"
            v-model="etiquetaColorText"
            label="Texto em branco?"
          ></v-switch>
          <v-chip
            id="prevColor"
            v-if="etiquetaTitle"
            :dark="etiquetaColorText"
            width="100%"
            class="ma-3"
          >
            {{ etiquetaTitle }}
          </v-chip>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cadEtiqueta()" color="primary" dark>Cadastrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="60%" v-model="system.modelRemoveCredenciado" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title
          >Remover Serviços
          <v-spacer></v-spacer>
          <v-btn icon @click="[(system.modelRemoveCredenciado = false)]">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="justify-center align-center">
          <v-row
            v-for="(credenciado, index) in credenciadosAddRemove"
            :key="index"
          >
            <v-col cols="5">
              <v-text-field
                v-model="credenciadosCadRemove[index].Nome"
                prepend-icon="mdi-account-multiple"
                label="Profissional"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="credenciadosCadRemove[index].Procedimento"
                label="Procedimento"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <v-text-field
                v-model="credenciadosCadRemove[index].quantidadePessoas"
                label="Funcionários"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn
                v-show="credenciadosAddRemove > 0"
                @click="
                  [
                    deleteServico(
                      credenciadosCadRemove[index].IdAgendamentoServico,
                      cadastro.IdAgendamento
                    ),
                  ]
                "
                color="red mt-3"
                small
                fab
                dark
              >
                <v-icon>mdi-account-multiple-minus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Visualização de anexos -->
    <v-dialog width="50%" v-model="system.modalAnexos" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title>
          Anexos
          <v-spacer></v-spacer>
          <v-btn icon @click="system.modalAnexos = !system.modalAnexos">
            <v-icon>mdi-close-box</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-list>
                <v-list-item-group color="primary">
                  <v-list-item v-for="(item, i) in anexos" :key="i">
                    <v-list-item-icon>
                      <v-icon>mdi-file-pdf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-btn text>
                        <v-list-item-title
                          @click="docOpen(item)"
                          v-text="item.originalName"
                        ></v-list-item-title>
                      </v-btn>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Opções de notificação de email do agendamento -->
    <v-dialog width="50%" v-model="system.opcoesNotificacaoEmail" :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card>
        <v-card-title>
          {{ emailNotificacao.message }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-radio-group
                :mandatory="true"
                v-model="emailOption"
              >
                <v-radio
                  v-for="(item, i) in emailNotificacao.options" :key="i"
                  :label="item"
                  :value="i"
                  name="emailOption"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="system.opcoesNotificacaoEmail = !system.opcoesNotificacaoEmail"
          >
            Fechar
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="notificarAgendamento(emailIdAgendamento, emailOption); system.opcoesNotificacaoEmail = !system.opcoesNotificacaoEmail"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <AlertSystem :snackbar="system.snackbar"></AlertSystem>
  </v-container>
</template>

<script>
import 'vue-multiselect/dist/vue-multiselect.min.css'
import AlertSystem from "../components/AlertSystem.vue";
import StatusProcesso from "../components/StatusProcesso.vue";
import OcorrenciasProcesso from "../components/OcorrenciasProcesso.vue";
import moment from "moment";
import Multiselect from 'vue-multiselect';
export default {
  name: "PreAgendamento",
  components: {
    Multiselect,
    AlertSystem,
    StatusProcesso,
    OcorrenciasProcesso
  },
  data: () => ({
    headers: [
      { text: "CNPJ", value: "CNPJ", width: "12%" },
      { text: "Razão Social", value: "RazaoSocial", width: "15%" },
      { text: "Contrato", value: "NumeroContrato", width: "6%" },
      { text: 'Unidade', value: 'Unidade', width: "12%"},
      { text: "Título", value: "titulo", width: "15%" },
      { text: "Data Inicial", value: "dataInicial", width: "12%" },
      { text: "Tipo", value: "statusProcesso", align: "center", width: "12%" },
      { text: "Ações", value: "actions", align: "right", width: "14%" },
    ],
    // ocorrencias: null,
    // cadQuantidadeExecutada: null,
    // servicos: null,
    // servicosTratados: null,
    // reloadIdServico: null,
    // reloadIdAgendamento: null,
    // execucoes: null,
    search: "",
    agendamentosList: [],
    myloadingvariable: false,
    notificacaoEmAndamento: false,
    alertasTimeout: null,
    system: {
      opcoesNotificacaoEmail: false,
      modalAnexos: false,
      modelCadEvento: false,
      modelRemoveCredenciado: false,
      btnlEditEvento: false,
      alertError: false,
      alertInfo: null,
      alertAction: null,
      action: "",
      snackbar: {},
      showAlerts: false,
      alerts: [],
    },
    dateTimes: {
      menuDataInicial: false,
      menuHoraInicial: false,
      menuDataFinal: false,
      menuHoraFinal: false,
      menuHoraSaida: false,
      menuDataSaida: false,
    },
    datasFormatadas: {
      dataInicial: "",
      dataFinal: "",
      dataSaida: "",
    },
    //   Etiqueta
    diagEtiquetas: false,
    situacaoEmpresa: null,
    colorBloqueada: "blue",
    labelEmpresaSituacao:"Empresa",
    etiquetaTitle: "Informe um título",
    etiquetaColor: null,
    etiquetaColorText: true,
    // Ocorrências
    diagEvidencias: false,
    diagViewEvidencias: false,
    ocorrenciasList: [],
    ocorrenciaDescricao: '',
    // Listas
    credenciadosList: [],
    credenciadosPorServico: {},
    empresasList: [],
    contratosList: [],
    procedimentosList: [],
    servicosContrato: [],
    servicoParaAdicionar: null,
    etiquetasList: [],
    // filtros
    credenciadosFilter: [],
    empresasFilter: [],
    numEmpregados: "-",
    emailsEmpresa: "",
    statusAgendamento: null,
    unidadesList: [],
    tecnicosList: [],
    deslocamento: [
      {
        id: 0,
        name: 'Não'
      },
      {
        id: 1,
        name: 'Sim'
      }
    ],
    tecnicosPlaceholder: 'Adicionar técnicos (0)',
    tecnicoSelect: false,
    tecnicos: [],
    // Dados para cadastro
    cadastro: {
      IdAgendamento: "",
      titulo: "",
      IdUnidade: "",
      IdEmpresa: "",
      IdContrato: "",
      IdEtiqueta: "",
      dataInicial: "",
      horaInicial: "",
      dataFinal: "",
      horaFinal: "",
      horaSaida: "",
      dataSaida: "",
      descricao: "",
      descricaoInterno: "",
      status: "",
      preAgendado: 1,
      anexos: [],
      cobrarTaxaDeslocamento: "",
    },

    // deslocamento: [
    //     { id: 'Sim', name: 'Sim' },
    //     { id: 'Não', name: 'Não' },
    // ],

    IdUnidadeFiltro: null,
    TipoFiltro: null,
    IdMes: null,
    periodosList: [
      {
        IdMes: 1,
        Mes: "Janeiro",
      },
      {
        IdMes: 2,
        Mes: "Fevereiro",
      },
      {
        IdMes: 3,
        Mes: "Março",
      },
      {
        IdMes: 4,
        Mes: "Abril",
      },
      {
        IdMes: 5,
        Mes: "Maio",
      },
      {
        IdMes: 6,
        Mes: "Junho",
      },
      {
        IdMes: 7,
        Mes: "Julho",
      },
      {
        IdMes: 8,
        Mes: "Agosto",
      },
      {
        IdMes: 9,
        Mes: "Setembro",
      },
      {
        IdMes: 10,
        Mes: "Outubro",
      },
      {
        IdMes: 11,
        Mes: "Novembro",
      },
      {
        IdMes: 12,
        Mes: "Dezembro",
      },
    ],
    IdAno: moment().format('YYYY'),
    anoList: [
      {
        IdAno: moment().format('YYYY'),
      },
      //ano anterior
      {
        IdAno: moment().format('YYYY')-1,
      }
    ],
    dynamicCol: 3,
    // IdUnidade: '',
    IdEmpresa: "",
    dia: null,
    segunda: null,
    terca: null,
    quarta: null,
    quinta: null,
    sexta: null,
    sabado: null,
    domingo: null,
    agendamentos: null,
    credenciadosAdd: 0,
    credenciadosAddRemove: 1,
    variavelHorarioTarde: null,
    // Anexos
    files: null,
    anexos: [],
    // opcoes de notificacao de email
    emailNotificacao: {
      message: "",
      options: []
    },
    emailOption: 0,
    emailIdAgendamento: "",
    // credenciados que vão pra o cadastro do evento
    credenciadosCad: [],
    IdCredenciado: null,
    credenciadosCadRemove: [
      {
        IdAgendamentoServico: "",
        Nome: "",
        Procedimento: "",
        quantidadePessoas: "",
      },
    ],
  }),
  computed: {
    verificaHoraChegada(){
      return this.cadastro.dataInicial === this.cadastro.dataSaida && this.horaValida(this.cadastro.horaSaida)
        ? this.cadastro.horaSaida
        : '00:00'
    },
    verificaHoraSaida(){
      return this.cadastro.dataInicial === this.cadastro.dataFinal && this.horaValida(this.cadastro.horaInicial)
        ? this.cadastro.horaInicial
        : '00:00'
    },
    horariosCadastroValidos(){
      return this.horaVaziaOuValida(this.cadastro.horaSaida) &&
        this.horaVaziaOuValida(this.cadastro.horaInicial) &&
        this.horaVaziaOuValida(this.cadastro.horaFinal)
    },
    agendamentoPodeSalvar(){
      return this.horariosCadastroValidos && this.cadastro.IdContrato != null && this.cadastro.IdContrato !== ""
    },
    servicosDisponiveisParaAdicionar() {
      const servicosSelecionados = this.credenciadosCad.map((credenciado) => credenciado.IdProcedimento);

      return this.servicosContrato.filter((servico) =>
        !servicosSelecionados.includes(servico.IdProcedimento)
      );
    }
  },
  methods: {
    formatarDataParaExibicao(data) {
      if (!data) return "";

      const dataMoment = moment(data, "YYYY-MM-DD", true);
      return dataMoment.isValid() ? dataMoment.format("DD/MM/YYYY") : "";
    },
    converterDataDigitada(data) {
      const dataMoment = moment(data, "DD/MM/YYYY", true);
      return dataMoment.isValid() ? dataMoment.format("YYYY-MM-DD") : null;
    },
    dataMaiorOuIgual(data, dataMinima) {
      return !dataMinima || data >= dataMinima;
    },
    sincronizarDataFormatada(campo) {
      this.datasFormatadas[campo] = this.formatarDataParaExibicao(this.cadastro[campo]);
    },
    sincronizarDatasFormatadas() {
      this.sincronizarDataFormatada("dataSaida");
      this.sincronizarDataFormatada("dataInicial");
      this.sincronizarDataFormatada("dataFinal");
    },
    abrirMenuData(menu) {
      this.dateTimes[menu] = true;
    },
    selecionarDataSaida() {
      this.dateTimes.menuDataSaida = false;
      this.cadastro.dataInicial = this.cadastro.dataSaida;
      this.cadastro.dataFinal = this.cadastro.dataSaida;
      this.sincronizarDatasFormatadas();
    },
    selecionarDataInicial() {
      this.dateTimes.menuDataInicial = false;
      this.cadastro.dataFinal = this.cadastro.dataInicial;
      this.credenciadosList = [];
      this.sincronizarDatasFormatadas();
      this.atualizarCredenciadosParaAgendamento();
    },
    selecionarDataFinal() {
      this.dateTimes.menuDataFinal = false;
      this.credenciadosList = [];
      this.sincronizarDataFormatada("dataFinal");
      this.atualizarCredenciadosParaAgendamento();
    },
    limparDataDigitada(campo) {
      this.cadastro[campo] = "";
      this.sincronizarDataFormatada(campo);

      if (campo === "dataSaida") {
        this.cadastro.dataInicial = "";
        this.cadastro.dataFinal = "";
        this.sincronizarDatasFormatadas();
      }

      if (campo === "dataInicial") {
        this.cadastro.dataFinal = "";
        this.sincronizarDataFormatada("dataFinal");
      }
    },
    atualizarDataDigitada(campo, data) {
      const dataConvertida = this.converterDataDigitada(data);

      if (!dataConvertida) {
        if (data === "" || data.length === 10) this.limparDataDigitada(campo);
        return;
      }

      this.cadastro[campo] = dataConvertida;

      if (campo === "dataSaida") {
        this.cadastro.dataInicial = dataConvertida;
        this.cadastro.dataFinal = dataConvertida;
        this.sincronizarDatasFormatadas();
      }

      if (campo === "dataInicial") {
        if (!this.dataMaiorOuIgual(dataConvertida, this.cadastro.dataSaida)) {
          this.limparDataDigitada(campo);
          return;
        }

        this.cadastro.dataFinal = dataConvertida;
        this.credenciadosList = [];
        this.sincronizarDataFormatada("dataFinal");
        this.atualizarCredenciadosParaAgendamento();
      }

      if (campo === "dataFinal") {
        if (!this.dataMaiorOuIgual(dataConvertida, this.cadastro.dataInicial)) {
          this.limparDataDigitada(campo);
          return;
        }

        this.credenciadosList = [];
        this.atualizarCredenciadosParaAgendamento();
      }
    },
    horaValida(hora) {
      return /^([01]\d|2[0-3]):[0-5]\d$/.test(hora);
    },
    horaVaziaOuValida(hora) {
      return hora === "" || this.horaValida(hora);
    },
    mensagemHoraInvalida(hora) {
      if (!hora || hora.length < 5 || this.horaValida(hora)) return [];

      return ["Informe uma hora entre 00:00 e 23:59"];
    },
    horaMaiorOuIgual(hora, horaMinima) {
      return !this.horaValida(horaMinima) || hora >= horaMinima;
    },
    abrirMenuHora(campo, menu) {
      if (this.cadastro[campo] && !this.horaValida(this.cadastro[campo])) return;

      this.dateTimes[menu] = true;
    },
    atualizarHoraSaida(hora) {
      if (this.horaValida(hora)) return;

      this.cadastro.horaInicial = "";
      this.cadastro.horaFinal = "";
      this.credenciadosList = [];
      this.tecnicosList = [];
    },
    atualizarHoraInicial(hora) {
      if (!this.horaValida(hora)) return;
      if (!this.horaMaiorOuIgual(hora, this.verificaHoraChegada)) return;

      this.cadastro.horaFinal = "";
      this.credenciadosList = [];
      this.tecnicosList = [];
      this.getTecnicos();
      this.atualizarCredenciadosParaAgendamento();
    },
    atualizarHoraFinal(hora) {
      if (!this.horaValida(hora)) return;
      if (!this.horaMaiorOuIgual(hora, this.verificaHoraSaida)) return;

      this.credenciadosList = [];
      this.atualizarCredenciadosParaAgendamento();
    },
    async docOpen(url){
      await this.axios.get('agendamentos/anexos', {
        params: {
          url: `${url.filename}`
        },
        responseType: 'arraybuffer'
      }).then(res => {

        let link = URL.createObjectURL(new Blob([res.data], {type: 'application/pdf'}))
        window.open(link)
      })
    },
    getIdUnidade(IdUnidade) {
      this.IdUnidade = IdUnidade;
    },
    getIdEmpresa(IdEmpresa) {
      this.IdEmpresa = IdEmpresa;
    },
    getOcorrencia (agendamento) {
      this.myloadingvariable = true
      this.axios.get(`agendamentos/${agendamento.IdAgendamento}/ocorrencias`).then( res => {
        this.ocorrenciasList = res.data
      }).catch( () => {

      }).finally(() => {
        this.myloadingvariable = false
      })
    },
    verificaEnviaDia(dia) {
      this.zerarDias();
      if (dia === 0) {
        this.domingo = 1;
      }
      if (dia === 1) {
        this.segunda = 1;
      }
      if (dia === 2) {
        this.terca = 1;
      }
      if (dia === 3) {
        this.quarta = 1;
      }
      if (dia === 4) {
        this.quinta = 1;
      }
      if (dia === 5) {
        this.sexta = 1;
      }
      if (dia === 6) {
        this.sabado = 1;
      }
    },
    verificaHorarioTarde() {
      if (this.cadastro.horaInicial == "12:00") {
        this.variavelHorarioTarde = "12:00:01";
      } else {
        this.variavelHorarioTarde = this.cadastro.horaInicial + ":00";
      }
    },
    getTecnicosAgendamento(idAgendamento){
      this.axios(`tecnicos/${idAgendamento}`, {
        params:{
          IdAgendamento: this.cadastro.IdAgendamento,
        },
      }).then((res) => {
        this.tecnicos = res.data;
      })
    },
    getTecnicos(){
      this.verificaHorarioTarde()
      if(this.cadastro.IdUnidade!=null && this.cadastro.horaInicial!=null){
        this.axios('tecnicos', {
          params: {
            horario: this.variavelHorarioTarde,
            IdUnidade: this.cadastro.IdUnidade
          },
        }).then((res) => {
          this.tecnicosList = res.data;
          this.tecnicosPlaceholder = 'Adicionar técnicos (' + (res.data.length) + ')';
          this.tecnicoSelect = true;
        })
      }
    },
    addTag (newTag) {
      const tag = {
        nome: newTag,
        IdProfissional: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.tecnicos.push(tag)
    },
    atualizarCredenciadosParaAgendamento() {
      if (!this.system.btnlEditEvento && this.cadastro.IdContrato) {
        return this.getProcedimentosContrato(this.cadastro.IdContrato);
      }
    },
    getEmpresas(IdUnidade) {
      this.getIdUnidade(IdUnidade);
      this.empresasList = [];
      this.contratosList = [];
      this.procedimentosList = [];
      this.credenciadosList = [];
      this.labelEmpresaSituacao = "Empresa";
      this.colorBloqueada = "blue";
      this.axios(`unidades/${IdUnidade}/empresas`).then((res) => {
        this.empresasList = res.data.map((elem) => {
          elem.RazaoSocial = this.prepareNameFilter(elem.RazaoSocial);
          return {
            IdEmpresa: elem.IdEmpresa,
            RazaoSocial: `${elem.RazaoSocial} ( ${elem.CNPJ} )`,
          };
        });
      });
    },
    getAllEmpresas(IdUnidade, IdContrato) {
      this.getIdUnidade(IdUnidade);
      this.empresasList = [];
      this.contratosList = [];
      this.procedimentosList = [];
      this.credenciadosList = [];
      this.labelEmpresaSituacao = "Empresa";
      this.colorBloqueada = "blue";
      this.axios(`unidades/${IdUnidade}/all-empresas/${IdContrato}`).then((res) => {
        this.empresasList = res.data.map((elem) => {
          elem.RazaoSocial = this.prepareNameFilter(elem.RazaoSocial);
          return {
            IdEmpresa: elem.IdEmpresa,
            RazaoSocial: `${elem.RazaoSocial} ( ${elem.CNPJ} )`,
          };
        });
      });
    },
    formatarContrato(elem) {
      return `nº ${elem.NumeroContrato} - ${this.tipoContrato(elem.TipoContrato)}`;
    },
    getContratos(IdEmpresa, limparSelecao = true) {
      if (limparSelecao) {
        this.cadastro.IdContrato = null;
        this.limparServicosSelecionados();
        this.credenciadosList = [];
      }

      if (!IdEmpresa || !this.cadastro.IdUnidade) {
        this.contratosList = [];
        return Promise.resolve();
      }

      return this.axios.get("/termos", {
        params: {
          IdSituacao: 1,
          IdUnidade: this.cadastro.IdUnidade,
          IdEmpresa: IdEmpresa,
        },
      }).then((res) => {
        this.contratosList = res.data.map((elem) => {
          return {
            ...elem,
            Contrato: this.formatarContrato(elem),
          };
        });
      }).catch((error) => {
        this.contratosList = [];
        this.system.snackbar = {
          snackbar: true,
          text: error.response.data,
          color: "red",
        };
      });
    },
    getProcedimentosContrato(IdContrato) {
      this.limparServicosSelecionados();
      this.credenciadosList = [];

      if (!IdContrato || !this.cadastro.dataInicial || !this.horaValida(this.cadastro.horaInicial)) return;

      return this.axios.get(`contratos/${IdContrato}/servicos-credenciados`, {
        params: {
          dataEvento: this.cadastro.dataInicial,
          horaInicial: this.cadastro.horaInicial,
        },
      }).then(
        (res) => {
          const servicos = res.data.servicos || [];
          this.procedimentosList = servicos.map((elem) => {
            return {
              IdProcedimento: elem.IdItem, //Retorando o Id do Item
              ServicoContratado: `${
                elem.ServicoContratado
              }`,
            };
          });
          this.credenciadosPorServico = servicos.reduce((credenciados, servico) => {
            credenciados[servico.IdItem] = servico.credenciados || [];
            return credenciados;
          }, {});
          this.credenciadosCad = this.procedimentosList.map((procedimento) => ({
            IdProfissional: "",
            IdProcedimento: procedimento.IdProcedimento,
            quantidadePessoas: 1,
          }));
          this.credenciadosAdd = this.credenciadosCad.length;
        }
      ).catch((error) => {
        this.system.snackbar = {
          snackbar: true,
          text: error.response ? error.response.data : "Não foi possível carregar os serviços do contrato.",
          color: "red",
        };
      });
    },
    tipoContrato(contratoTipo) {
      const tipos = [   
        '',     
        'Portal de Serviços',     // Índice 1
        'Termo de Acatamento',    // Índice 2
        'Outros',                 // Índice 3
        'Indústria Mais Segura'   // Índice 4
      ];

      return tipos[contratoTipo];
    },
    
    getNumEmpregados(IdEmpresa) {
      this.axios.get(`empresas/${IdEmpresa}`).then((res) => {
        this.numEmpregados = res.data.NumEmpregados;
        const fontesDeEmail = [
          res.data.cad_empresa && res.data.cad_empresa.email,
          res.data.cad_empresa && res.data.cad_empresa.Email,
          res.data.email,
          res.data.Email,
        ];
        const emails = fontesDeEmail.find((email) => email !== undefined && email !== null) || "";

        this.emailsEmpresa = Array.isArray(emails)
          ? emails.join("\n")
          : emails || "";
      });
    },
    getUnidades() {
      this.axios("unidades").then((res) => {
        this.unidadesList = res.data;
      });
    },
    getAgendamentos() {
      this.myloadingvariable = true;
      this.axios("agendamentos", {
        params: {
          IdUnidade:      this.IdUnidadeFiltro,
          IdEmpresa:      this.IdEmpresa,
          IdCredenciado:  this.IdCredenciado,
          IdMes:          this.IdMes,
          IdAno:          this.IdAno,
          IdEtiqueta:     this.TipoFiltro
        },
      })
        .then((res) => {
          this.agendamentosList = res.data.filter((agendamento) => {
            agendamento.RazaoSocial = this.prepareNameFilter(agendamento.RazaoSocial);
            if (agendamento.IdStatusProcesso <= 1) {
              return agendamento;
            }
          });
        })
        .catch(() => {})
        .finally(() => {
          this.myloadingvariable = false;
        });
    },
    getEtiquetas() {
      this.axios("etiquetas").then((res) => {
        this.etiquetasList = res.data;
      });
    },
    viewAnexos(anexos) {
      this.anexos = anexos;
    },
    deletarAnexo(id) {
      this.cadastro.anexos = this.cadastro.anexos.filter(
        (anexo) => anexo.id !== id
      );
      this.axios
        .delete(`agendamentos/anexos/${id}`)
        .then(() => {
          this.getAgendamentos();
        })
        .catch((error) => {
          this.system.snackbar = {
            snackbar: true,
            text: error.response,
            color: "red",
          };
        });
    },
    getIdAgendamentoOcorrenvia (agendamento) {
      this.IdAgendamentoOcorrenvia = agendamento.IdAgendamento
    },
    cadOcorrencias () {
      this.axios.post(`agendamentos/${this.IdAgendamentoOcorrenvia}/ocorrencias`, {
        ocorrenciaDescricao: this.ocorrenciaDescricao
      }).then( res => {
        this.system.snackbar = {
          snackbar: true,
          text: res.data,
          color: "green",
        };
        this.diagEvidencias = false
        this.ocorrenciaDescricao = ''
      }).catch(e => {
        this.system.snackbar = {
          snackbar: true,
          text: e.response.data.ocorrenciaDescricao[0],
          color: "red",
        };
      })
    },
    // cadastra agendamentos
    cadEvento() {
      if (this.situacaoEmpresa == 1) {
        this.system.snackbar = {
          snackbar: true,
          text: "A empresa encontra-se bloqueada",
          color: "red",
        };
      } else {
        this.myloadingvariable = true;

        let formData = new FormData();
        // anexos
        if (this.files) {
          for (let i = 0; i < this.files.length; i++) {
            let file = this.files[i];
            formData.append(`files[${i}]`, file);
          }
        }
        // dados de cadastro
        for (let key in this.cadastro) {
          formData.append(`cadastro[${key}]`, this.cadastro[key]);
        }
        // dados dos credenciados
        for (let i = 0; i < this.credenciadosCad.length; i++) {
          for (let key in this.credenciadosCad[i]) {
            formData.append(
                `credenciados[${i}][${key}]`,
                this.credenciadosCad[i][key]
            );
          }
        }

        if (this.tecnicos!=null) {
          for (let i = 0; i < this.tecnicos.length; i++) {
            formData.append(
                `tecnicos[${i}]`,
                this.tecnicos[i]['IdProfissional']
            );
          }
        }

        this.axios
          .post("agendamentos", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            this.system.modelCadEvento = false;
            this.zerarCampos();
            this.getAgendamentos();

            this.system.snackbar = {
              snackbar: true,
              text: res.data,
              color: "green",
            };
          })
          .catch((error) => {
            this.system.alertError = true;
            this.system.alertInfo = error.response.data;
          })
          .finally(() => {
            this.myloadingvariable = false;
          });
      }
    },
    async loadEvento(idAgendamento, IdEmpresa, IdUnidade, IdContrato) {
      this.myloadingvariable = true;
      await this.getAllEmpresas(IdUnidade, IdContrato);
      await this.axios
        .get(`agendamentos/${idAgendamento}/servicos`)
        .then((res) => {
          this.popularServicosAgendamento(res.data);
        })
        .finally(() => {
          this.myloadingvariable = false;
        });
      this.agendamentosList.map((elem) => {
        if (elem.IdAgendamento == idAgendamento) {
          this.cadastro.IdAgendamento = elem.IdAgendamento;
          this.cadastro.titulo = elem.titulo;
          this.cadastro.IdUnidade = elem.IdUnidade;
          this.cadastro.IdEmpresa = elem.IdEmpresa;
          this.cadastro.IdContrato = elem.IdContrato;
          this.cadastro.IdEtiqueta = elem.IdEtiqueta;
          this.cadastro.dataInicial = elem.dataInicial;
          this.cadastro.dataFinal = elem.dataFinal;
          this.cadastro.dataSaida = elem.dataSaida;
          this.cadastro.horaInicial = elem.dataInicial;
          this.cadastro.horaFinal = elem.dataFinal;
          this.cadastro.horaSaida = elem.dataSaida;
          this.cadastro.cobrarTaxaDeslocamento = elem.cobrarTaxaDeslocamento;
          if (elem.descricao != null)
            this.cadastro.descricao = elem.descricao;
          if (elem.obs_interna != null)
            this.cadastro.descricaoInterno = elem.obs_interna;
          this.cadastro.status = elem.status;
          this.cadastro.nome = elem.Nome;
          this.cadastro.anexos = elem.anexos || [];
        }
      });
      this.cadastro.dataInicial = moment(this.cadastro.dataInicial).format("YYYY-MM-DD");
      this.cadastro.dataFinal   = moment(this.cadastro.dataFinal).format("YYYY-MM-DD");
      this.cadastro.dataSaida   = moment(this.cadastro.dataSaida).format("YYYY-MM-DD");
      this.cadastro.horaInicial = moment(this.cadastro.horaInicial).format("LT");
      this.cadastro.horaFinal   = moment(this.cadastro.horaFinal).format("LT");
      this.cadastro.horaSaida   = moment(this.cadastro.horaSaida).format("LT");
      this.sincronizarDatasFormatadas();
      await this.getContratos(IdEmpresa, false);
      await this.carregarServicosContratoParaEdicao(this.cadastro.IdContrato);
      this.getTecnicos()
      this.getTecnicosAgendamento(this.cadastro.IdAgendamento);
      this.getNumEmpregados(this.cadastro.IdEmpresa);
    },
    zerarDias() {
      (this.segunda = null),
        (this.terca = null),
        (this.quarta = null),
        (this.quinta = null),
        (this.sexta = null),
        (this.sabado = null),
        (this.domingo = null);
    },
    zerarCampos() {
      this.cadastro.IdAgendamento = null;
      this.cadastro.titulo = '';
      this.cadastro.cobrarTaxaDeslocamento = '';
      this.cadastro.IdUnidade = null;
      this.cadastro.IdEmpresa = null;
      this.cadastro.IdContrato = null;
      this.cadastro.IdEtiqueta = null;
      this.cadastro.descricao = "";
      this.cadastro.descricaoInterno = "";
      this.cadastro.status = null;
      this.cadastro.dataInicial = "";
      this.cadastro.dataFinal = "";
      this.cadastro.horaInicial = "";
      this.cadastro.horaFinal = "";
      this.cadastro.horaSaida = "";
      this.cadastro.dataSaida = "";
      this.sincronizarDatasFormatadas();
      this.cadastro.anexos = [];
      this.tecnicos = [];
      this.tecnicosList = [];
      this.tecnicoSelect = false;
      this.tecnicosPlaceholder = 'Adicionar técnicos (0)';
      this.zerarDias();
      (this.dia = null),
        (this.variavelHorarioTarde = null),
        // this.dateTimes.menuDataInicial = false
        // this.dateTimes.menuHoraInicial = false
        // this.dateTimes.menuDataFinal = false
        // this.dateTimes.menuHoraFinal = false

      this.limparServicosSelecionados();
      this.contratosList = [];
      this.procedimentosList = [];
      this.servicosContrato = [];
      this.servicoParaAdicionar = null;
      this.numEmpregados = "-";
      this.emailsEmpresa = "";
      this.system.btnlEditEvento = false;
    },
    editEvento(idAgendamento) {
      if (this.cadastro.IdEtiqueta == null) {
        this.cadastro.IdEtiqueta = "";
      }
      let formData = new FormData();
      // anexos
      if (this.files) {
        for (let i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          formData.append(`files[${i}]`, file);
        }
      }
      // tecnicos
      if (this.tecnicos!=null) {
        for (let i = 0; i < this.tecnicos.length; i++) {
          formData.append(
              `tecnicos[${i}]`,
              this.tecnicos[i]['IdProfissional']
          );
        }
      }
      // dados de cadastro
      for (let key in this.cadastro) {
        formData.append(`cadastro[${key}]`, this.cadastro[key]);
      }
      // dados dos credenciados
      for (let i = 0; i < this.credenciadosCad.length; i++) {
        for (let key in this.credenciadosCad[i]) {
          formData.append(
            `credenciados[${i}][${key}]`,
            this.credenciadosCad[i][key]
          );
        }
      }
      formData.append("idAgendamentos", this.credenciadosListServicos);
      // necessário devido limitaçoes do php com form-data
      formData.append("_method", "PUT");

      this.axios
        .post(`agendamentos/${idAgendamento}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          this.system.modelCadEvento = false;
          this.zerarCampos();
          this.getAgendamentos();
          this.system.snackbar = {
            snackbar: true,
            text: res.data,
            color: "green",
          };
        })
        .catch((error) => {
          this.system.alertError = true;
          this.system.alertInfo = error.response.data;
        });
    },
    async exportarTrabalhadores(IdAgendamento) {
      this.myloadingvariable = true;

      try {
        const response = await this.axios.get(
          `agendamentos/${IdAgendamento}/exportar-trabalhadores`,
          { responseType: "arraybuffer" }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", `trabalhadores-agendamento-${IdAgendamento}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } finally {
        this.myloadingvariable = false;
      }
    },
    deleteEvento(IdAgendamento) {
      if (this.notificacaoEmAndamento) return;

      let del = confirm("Deseja realmente excluir esse evento?");

      if (del) {
        this.myloadingvariable = true;

        this.axios
          .delete(`agendamentos/${IdAgendamento}`)
          .then((res) => {
            this.system.snackbar = {
              snackbar: true,
              text: res.data,
              color: "green",
            };
            this.getAgendamentos();
          })
          .catch((error) => {
            this.system.snackbar = {
              snackbar: true,
              text: error.response,
              color: "red",
            };
          })
          .finally(() => {
            this.myloadingvariable = false;
          });
      }
    },
    cadEtiqueta() {
      this.axios
        .post("etiquetas", {
          titulo: this.etiquetaTitle,
          cor: this.etiquetaColor.hexa,
          corTexto: this.etiquetaColorText,
        })
        .then((res) => {
          this.getEtiquetas();
          this.cadastro.IdEtiqueta = res.data.IdEtiqueta;
          this.diagEtiquetas = false;
          this.system.snackbar = {
            snackbar: true,
            text: res.data.message,
            color: "green",
          };
        })
        .catch((error) => {
          this.system.snackbar = {
            snackbar: true,
            text: error.response,
            color: "red",
          };
        });
    },
    limparServicosSelecionados() {
      this.procedimentosList = [];
      this.servicosContrato = [];
      this.servicoParaAdicionar = null;
      this.credenciadosCad = [];
      this.credenciadosPorServico = {};
      this.credenciadosAdd = 0;
    },
    temProfissionalAgendado(servico) {
      const IdProfissional =
        servico.IdCredenciado !== null && servico.IdCredenciado !== undefined
          ? servico.IdCredenciado
          : servico.IdProfissional;

      return IdProfissional !== null && IdProfissional !== undefined && IdProfissional !== "";
    },
    popularServicosAgendamento(servicos) {
      const servicosAgendados = servicos.filter((servico) =>
        servico.IdAgendamentoServico != null &&
        servico.SeqItemContrato &&
        this.temProfissionalAgendado(servico)
      );

      this.procedimentosList = servicosAgendados.map((servico) => ({
        IdProcedimento: servico.SeqItemContrato,
        ServicoContratado: servico.Procedimento,
      }));
      this.credenciadosPorServico = servicosAgendados.reduce((credenciados, servico) => {
        credenciados[servico.SeqItemContrato] = servico.credenciados || [];
        return credenciados;
      }, {});
      this.credenciadosCad = servicosAgendados.map((servico) => ({
        IdAgendamentoServico: servico.IdAgendamentoServico,
        IdProfissional: servico.IdCredenciado,
        IdProcedimento: servico.SeqItemContrato,
        quantidadePessoas: servico.quantidadePessoas,
      }));
      this.credenciadosAdd = this.credenciadosCad.length;
    },
    carregarServicosContratoParaEdicao(IdContrato) {
      if (!IdContrato || !this.cadastro.dataInicial || !this.horaValida(this.cadastro.horaInicial)) {
        this.servicosContrato = [];
        return Promise.resolve();
      }

      return this.axios.get(`contratos/${IdContrato}/servicos-credenciados`, {
        params: {
          dataEvento: this.cadastro.dataInicial,
          horaInicial: this.cadastro.horaInicial,
        },
      }).then((res) => {
        this.servicosContrato = (res.data.servicos || []).map((servico) => ({
          IdProcedimento: servico.IdItem,
          ServicoContratado: servico.ServicoContratado,
          credenciados: servico.credenciados || [],
        }));
      }).catch((error) => {
        this.servicosContrato = [];
        this.system.snackbar = {
          snackbar: true,
          text: error.response ? error.response.data : "Não foi possível carregar os serviços do contrato.",
          color: "red",
        };
      });
    },
    adicionarServicoAoAgendamento(IdProcedimento) {
      const servico = this.servicosContrato.find((item) => item.IdProcedimento === IdProcedimento);

      if (!servico || this.credenciadosCad.some((credenciado) => credenciado.IdProcedimento === IdProcedimento)) {
        return;
      }

      this.procedimentosList.push({
        IdProcedimento: servico.IdProcedimento,
        ServicoContratado: servico.ServicoContratado,
      });
      this.credenciadosPorServico[servico.IdProcedimento] = servico.credenciados;
      this.credenciadosCad.push({
        IdProfissional: "",
        IdProcedimento: servico.IdProcedimento,
        quantidadePessoas: 1,
      });
      this.credenciadosAdd = this.credenciadosCad.length;
      this.servicoParaAdicionar = null;
    },
    credenciadosDoServico(IdItem) {
      return Object.prototype.hasOwnProperty.call(this.credenciadosPorServico, IdItem)
        ? this.credenciadosPorServico[IdItem]
        : this.credenciadosList;
    },
    removeCredenciado(indice) {
      if (this.credenciadosAdd > 1) {
        this.credenciadosAdd -= 1;
        this.credenciadosCad.splice(indice, 1);
      }
    },
    recarregarServicos(IdAgendamento) {
      return this.axios.get(`agendamentos/${IdAgendamento}/servicos`).then((res) => {
        const servicosAgendados = res.data.filter(this.temProfissionalAgendado);

        this.credenciadosCadRemove = servicosAgendados.map((servico) => ({
          IdAgendamentoServico: servico.IdAgendamentoServico,
          Nome: servico.Nome,
          Procedimento: servico.Procedimento,
          quantidadePessoas: servico.quantidadePessoas,
        }));
        this.credenciadosAddRemove = this.credenciadosCadRemove.length;
      });
    },
    deleteServico(IdAgendamentoServico, IdAgendamento) {
      if (this.credenciadosCadRemove.length == 1) {
        alert("Você não pode deletar todos os serviços");
      } else {
        let del = confirm("Deseja excluir esse serviço?");

        if (del) {
          this.myloadingvariable = true;

          this.axios
            .delete(`servicos/${IdAgendamentoServico}`)
            .then((res) => {
              alert(res.data);
            })
            .catch(() => {})
            .finally(() => {
              this.myloadingvariable = false;
              this.axios
                .get(`agendamentos/${IdAgendamento}/servicos`)
                .then((res) => {
                  this.popularServicosAgendamento(res.data);
                });
              this.system.modelRemoveCredenciado = false;
            });
        }
      }
    },
    checkNotificationsAgendamento(IdAgendamento) {
      if (this.notificacaoEmAndamento) return;

      this.notificacaoEmAndamento = true;
      this.myloadingvariable = true;
      return this.axios.get(`agendamentos/${IdAgendamento}/check`)
        .then((res) => {
          if (res.data.action == "send") {
            return this.notificarAgendamento(IdAgendamento, 6, true);
          } else {
            this.system.opcoesNotificacaoEmail = true;
            this.emailIdAgendamento = IdAgendamento;
            this.emailNotificacao.message = res.data.message;
            this.emailNotificacao.options = res.data.options;
          }
        })
        .catch((error) => {
          this.system.snackbar = {
            snackbar: true,
            text: error.response.data,
            color: "red",
          };
        })
        .finally(() => {
          this.notificacaoEmAndamento = false;
          this.myloadingvariable = false;
        });
    },
    notificarAgendamento(id, option, notificacaoJaEmAndamento = false) {
      if (this.notificacaoEmAndamento && !notificacaoJaEmAndamento) return;

      if (!notificacaoJaEmAndamento) {
        this.notificacaoEmAndamento = true;
      }
      this.myloadingvariable = true;
      return this.axios
        .get(`agendamentos/${id}/notify?option=${option}`)
        .then((res) => {
          this.system.showAlerts = true;
          this.system.alerts = [];
          this.system.alerts.push({
            ordem: 1,
            message: res.data.message,
            type: "success",
          });
          if (res.data.empresaNotificada) {
            this.system.alerts.push({
              ordem: 2,
              message: "A empresa foi notificada.",
              type: "success",
            });
          } else {
            this.system.alerts.push({
              ordem: 2,
              message:
                "A empresa não foi notificada pois não possui email no sistema.",
              type: "warning",
            });
          }
          if (res.data.credenciadosNaoNotificados > 0) {
            this.system.alerts.push({
              ordem: 3,
              message:
                "Alguns credenciados não foram notificados pois não possuem email no sistema",
              type: "warning",
            });
          } else {
            this.system.alerts.push({
              ordem: 3,
              message: "Os credenciados foram notificados.",
              type: "success",
            });
          }
          this.agendarFechamentoAlertas();
        })
        .catch((error) => {
          this.system.snackbar = {
            snackbar: true,
            text: error.response.data,
            color: "red",
          };
        })
        .finally(() => {
          if (!notificacaoJaEmAndamento) {
            this.notificacaoEmAndamento = false;
          }
          this.myloadingvariable = false;
        });
    },
    agendarFechamentoAlertas() {
      if (this.alertasTimeout) {
        clearTimeout(this.alertasTimeout);
      }

      this.alertasTimeout = setTimeout(() => {
        this.system.alerts = [];
        this.alertasTimeout = null;
      }, 10000);
    },
    getEmpresasFilter(){
        this.axios('empresas/calendario').then(res=>{
          this.empresasFilter = res.data
        })
      },
    getCredenciadosFiler(){
      this.axios('credenciados/calendario').then(res=>{
        this.credenciadosFilter = res.data
      })
    },
    limparFiltros() {
      this.IdUnidadeFiltro  = null
      this.IdEmpresa        = null
      this.IdCredenciado    = null
      this.IdMes            = null
      this.IdAno            = moment().format('YYYY')
      this.TipoFiltro       = null
      this.dynamicCol       = 2
      this.getAgendamentos();
    },
    getEmpresaBloqueada(IdEmpresa){
      this.axios(`empresas/${IdEmpresa}/bloqueio/${this.cadastro.IdUnidade}`).then((res) => {
        this.situacaoEmpresa = res.data;
        if(this.situacaoEmpresa == 1) {
          this.colorBloqueada = "red";
          this.labelEmpresaSituacao = "Empresa bloqueada";
        }else{
          this.colorBloqueada = "blue";
          this.labelEmpresaSituacao = "Empresa";
        }
      })
    },
  },
  beforeDestroy() {
    if (this.alertasTimeout) {
      clearTimeout(this.alertasTimeout);
    }
  },
  mounted() {
    // this.deletarAnexo(214)
    // this.getCredenciados()
    // this.getProcedimentos()
    this.getAgendamentos()
    this.getEtiquetas()
    this.getUnidades()
    this.getEmpresasFilter()
    this.getCredenciadosFiler()
  },
  watch: {
    etiquetaColor() {
      if (this.etiquetaColor != null) {
        let color = this.etiquetaColor.hexa,
          prevColor = document.getElementById("prevColor");

        prevColor.style.background = color;
      }
    },
    'cadastro.cobrarTaxaDeslocamento': function (val) {
      if (val == 1) {
        this.cadastro.cobrarTaxaDeslocamento = 1;
      } else {
        this.cadastro.cobrarTaxaDeslocamento = 0;
      }
    },
  },
};
</script>

<style>
.multiselect__tags {
  min-height: 32px;
  display: block;
  /*padding: 3px 40px 0 8px;*/
  border-radius: 5px;
  border: 1px solid #858382;
  background: #fff;
  font-size: 14px;
}
.multiselect__tag{
  background: darkblue;
}
.multiselect__option--highlight{
  background: darkblue;
}
.multiselect__option--highlight:after{
  background: #fff;
  color: black;
}

.multiselect__tag-icon:focus,.multiselect__tag-icon:hover{
  background: black;
}
.outline{
  border-style: dashed;
}

</style>
